"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pruneNonErrors = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var pruneArray = function pruneArray(errors) {
  var hasError = false;
  var results = errors.reduce(function (acc, value) {
    var children = pruneObject(value);

    if (children && Object.keys(children).length > 0) {
      hasError = true;
    }

    acc.push(children);
    return acc;
  }, []);
  return hasError ? results : [];
};

var pruneObject = function pruneObject(errors) {
  if (!errors) return errors;
  return Object.entries(errors).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (Array.isArray(value)) {
      var children = pruneArray(value);

      if (children.length > 0) {
        acc[key] = children;
      }

      if (value.error) {
        if (!acc[key]) acc[key] = [];
        acc[key].error = value.error;
      }

      return acc;
    }

    if ((0, _typeof2.default)(value) === 'object') {
      var _children = pruneObject(value);

      if (_children && Object.keys(_children).length > 0) {
        acc[key] = _children;
      }
    } else if (value) {
      acc[key] = value;
    }

    return acc;
  }, {});
};

var pruneNonErrors = function pruneNonErrors(errors) {
  return pruneObject(errors);
};

exports.pruneNonErrors = pruneNonErrors;